export const uk = {
    'banner-id': '№ {id}'
};
